import { apiClient } from './client';
import { CardapioPublico } from '../types';

export function buscarCardapioPublico(tenantId: string): Promise<CardapioPublico> {
  return apiClient.get(`/publico/cardapio/${tenantId}`).then((res) => res.data);
}
